<script>
import productMixin from '@/v-shop/mixins/product-mixin'

export default {
	mixins: [productMixin()],
	props: {
		receta: Object,
		referenciaRx: Object,
		product: Object,
		qty: Number,
		loading: Boolean,
		otherLoading: Boolean,
		num: Number,
		inCart: Boolean,
	},
	inject: ['getPickupPoints', 'getSelectedPickupPoint'],
	data() {
		return {
			internalQty: this.qty,
		}
	},
	computed: {
		variant() {
			return this.product.variants[0]
		},
		variantAttrsDescription() {
			if (this.product.hasUniqueVariant) return ''
			else return this.variant.attrs.map((attr) => `${attr.attrKey.k}: ${attr.v}`).join(' | ')
		},
		coberturaItem() {
			return this.receta.coberturaItems.find((x) => x.Droga.Codigo == this.referenciaRx.Droga.Codigo)
		},
		coberturaDiscount() {
			if (!this.coberturaItem?.CantidadAprobada) return 0
			return this.coberturaItem.PorcentajeCobertura || 0
		},
		calculatedPrice() {
			let price = this.price
			return Number((price * (1 - this.coberturaDiscount / 100)).toFixed(2))
		},
		selectedPickupPoint() {
			return this.getSelectedPickupPoint()
		},
		ppWithStock() {
			const pickupPoints = this.getPickupPoints()
			return (
				this.product.ppWithStock
					.map(({ id, qty }) => {
						const name = pickupPoints.find((p) => p.id == id).name
						return { id, name, qty }
					})
					.sort((a, b) => b.qty - a.qty) || []
			)
		},
		ppChipData() {
			const pplen = this.product.ppWithStock.length
			if (this.selectedPickupPoint) {
				if (this.product.ppTotalStock < this.internalQty && this.internalQty > 0) {
					if (this.product.ppTotalStock == 0) {
						return {
							message: `No hay stock disponible en la sucursal seleccionada`,
							color: 'error',
						}
					} else {
						return {
							message: `Solo ${this.product.ppTotalStock} unid. ${
								this.product.ppTotalStock === 1 ? 'disponible' : 'disponibles'
							} en sucursal seleccionada`,
							color: 'orange darken-1',
						}
					}
				}
				if (pplen) {
					return {
						message: `Disponible en sucursal seleccionada`,
						color: '',
						icon: 'mdi-check',
						iconColor: 'success',
					}
				} else {
					return {
						message: `No disponible en sucursal seleccionada`,
						color: 'error',
						icon: 'mdi-close',
						iconColor: 'error',
					}
				}
			} else {
				if (pplen) {
					return {
						message: `Disponible en ${pplen} sucursal${pplen === 1 ? '' : 'es'}`,
						color: '',
						icon: 'mdi-check',
						iconColor: 'success',
					}
				} else {
					return {
						message: `No disponible en ninguna sucursal`,
						color: 'error',
						icon: 'mdi-close',
						iconColor: 'error',
					}
				}
			}
		},
		quantitySelectItems() {
			let maxQty = parseInt(this.referenciaRx.CantidadPrescripta)
			let items = []
			for (let i = 1; i <= maxQty; i++) {
				items.push({ value: i, text: `${i} ${this.unitsWord(i)}` })
			}
			return items
		},
	},
	watch: {
		qty(value) {
			this.internalQty = value
		},
	},
	methods: {
		async updateInternalQty(value) {
			if (this.loading || this.disabled) return
			this.internalQty = Math.max(0, value)
			this.$emit('update:qty', value)
		},
		unitsWord(qty, smallForMobile = true) {
			return this.$b.m && smallForMobile ? 'unid.' : qty != 1 ? 'unidades' : 'unidad'
		},
	},
	mounted() {},
}
</script>

<template>
	<div>
		<!-- <div class="pb-2 font-weight-bold d-flex align-center nowrap" v-if="inCart">
			<v-icon color="success">mdi-chevron-right</v-icon>
			<div style="font-size: 12px">Opción seleccionada</div>
		</div> -->
		<div class="pb-2 font-weight-bold d-flex align-center nowrap" v-if="!inCart">
			<v-icon>mdi-chevron-right</v-icon>
			<div style="font-size: 12px">Opción #{{ num }}</div>
		</div>
		<div class="d-flex flex-column flex-sm-row align-sm-center receta-product-item" style="gap: 12px">
			<div class="d-flex align-start align-sm-center" :style="{ gap: $b.m ? '8px' : '12px', minWidth: 0 }">
				<div class="flex-shrink-0" :style="{ width: $b.m ? '40px' : '70px' }">
					<Media
						:src="product.images[0].medium"
						aspect-ratio="1"
						class="rounded-lg"
						style="border: 1px solid #ddd; cursor: pointer; overflow: hidden"
						width="100%"
					/>
				</div>
				<div class="flex-shrink-1">
					<b>{{ product.name }}</b>
					<div v-if="variantAttrsDescription">{{ variantAttrsDescription }}</div>
					<div class="mt-2">
						<v-menu
							bottom
							right
							max-width="300"
							min-width="200"
							offset-y
							open-on-hover
							:disabled="!!selectedPickupPoint"
						>
							<template #activator="{ on, attrs }">
								<v-chip
									class="ma-sm-1"
									small
									outlined
									v-bind="attrs"
									v-on="on"
									style="cursor: pointer; white-space: normal; height: unset"
									:color="ppChipData.color"
								>
									<v-icon
										v-if="ppChipData.icon"
										left
										small
										:color="ppChipData.iconColor"
										class="flex-shrink-0"
									>
										{{ ppChipData.icon }}
									</v-icon>
									<span> {{ ppChipData.message }} </span>
								</v-chip>
							</template>
							<v-card class="pa-4 pr-8" style="min-width: 300px">
								<div class="pb-2"><b>Sucursales con disponibilidad</b></div>
								<div v-if="!ppWithStock.length" class="grey--text text--darken-1">
									No hay stock disponible en ninguna sucursal
								</div>
								<div v-else class="d-flex flex-column" style="gap: 8px">
									<div v-for="pp of ppWithStock" :key="pp.id" class="d-flex align-center">
										<v-icon left small class="flex-shrink-0">mdi-store</v-icon>
										<span>{{ pp.name }}</span>
									</div>
								</div>
							</v-card>
						</v-menu>
					</div>
				</div>
			</div>
			<v-spacer v-if="!$b.m" />
			<div
				class="d-flex align-center"
				:style="$b({ m: { gap: '8px', width: '100%' }, _: { gap: '12px', width: '367px' } })"
			>
				<div
					class="flex-shrink-0 nowrap text-center"
					:style="$b({ m: { width: '40%' }, _: { width: '170px' } })"
				>
					<v-chip
						:small="!$b.m || !!coberturaDiscount"
						:x-small="$b.m && !coberturaDiscount"
						:color="coberturaDiscount ? 'success' : 'grey darken-2'"
						:outlined="!coberturaDiscount"
						class="mb-1"
					>
						<b v-if="coberturaDiscount">{{ $b.m ? 'Cob.' : 'Cobertura' }} {{ coberturaDiscount }}%</b>
						<span v-else>Sin Cobertura</span>
					</v-chip>
					<div
						class="d-flex flex-column flex-sm-row align-center justify-center"
						:style="{ gap: $b.m ? '' : '12px' }"
					>
						<div v-if="coberturaDiscount" class="receta-product-item__list-price--tachado font-1">
							{{ price | price({ currency, decimalCount: 0 }) }}
						</div>
						<ProductPrice
							custom-class="font-2 font-weight-bold"
							:amount="calculatedPrice"
							:currency="currency"
						/>
					</div>
				</div>
				<div class="flex-shrink-0 nowrap" :style="$b({ m: { width: '60%' }, _: { width: '185px' } })">
					<div class="pb-1 font-0 d-flex align-center pump" style="gap: 4px" v-if="inCart">
						<v-icon color="success">mdi-cart-check</v-icon>
						<b>Agregaste al carrito</b>
					</div>
					<div class="pb-1 font-0 d-flex align-center" style="gap: 4px" v-else>
						<v-icon small>mdi-cart-plus</v-icon>
						<b>Elegir cantidad</b>
					</div>
					<Select
						class="qty-select"
						style="width: 100%"
						:placeholder="`0 ${unitsWord(0)}`"
						:items="quantitySelectItems"
						dense
						hide-details
						:loading="loading"
						:disabled="otherLoading"
						:value="internalQty"
						@change="updateInternalQty($event)"
						:clearable="$b.d"
						@click:clear="updateInternalQty(0)"
						solo
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.receta-product-item {
	&__list-price--tachado {
		text-decoration: line-through;
		color: #aaa;
	}
}

@keyframes slideRight {
	from {
		transform: translateX(100px);
		opacity: 0.5;
	}
	to {
		transform: translateX(0);
		opacity: 1;
	}
}

.slide-right {
	animation-name: slideRight;
	animation-duration: 0.6s;
}

@keyframes pump {
	0% {
		transform: scale(1) translateX(30px);
		opacity: 0.7;
	}
	40% {
		transform: scale(1.05);
	}
	60% {
		transform: scale(0.98);
	}
	80% {
		transform: scale(1.01);
	}
	100% {
		transform: scale(1) translateX(0);
		opacity: 1;
	}
}

.pump {
	animation-name: pump;
	animation-duration: 1.2s;
}
</style>

